import { Button, getClassNameFactory } from '@dcl/ui';
import { ButtonColor, ButtonKind, IconPosition } from '@dcl/ui/dist/elements/Button';
import React, { useState } from 'react';
import { ILeftNav } from '../../types';
import DownArrow from './icons/DownArrow';
import UPArrow from './icons/UPArrow';
import { roleGroup, roleTree, roleTreeitem } from '../../../../constants';
import './LeftNavMobile.css';


export const LeftNavMobile: React.FC<ILeftNav> = (props) => {
    const getClassName = getClassNameFactory(LeftNavMobile.displayName);
    const { leftNavItems, scrollToId } = props;
    const [collapsedDiv, setCollapsedDiv] = React.useState(false);
    const [activeItem, setActiveItem] = useState<string | null>(leftNavItems.length > 0 ? leftNavItems[0].leftNavId : null);

    const handleItemClick = (leftNavId: string) => {
        setActiveItem(leftNavId);
        scrollToId(leftNavId);
    };

    const handleEnterPress = (e: React.KeyboardEvent, leftNavId: string) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // Prevent default click behavior
            setActiveItem(leftNavId);
        }
    }
    const handleExpandClick = () => {
        setCollapsedDiv(!collapsedDiv);
    }

    return (
        <div className={getClassName()}>
            <Button kind={ButtonKind.BUTTON} color={ButtonColor.SECONDARY}
                onClick={handleExpandClick}
                icon={collapsedDiv ? <UPArrow /> : <DownArrow />} iconPosition={IconPosition.RIGHT} block={true}>
                Show Menu
            </Button>
            {
                collapsedDiv && <div className={getClassName({ descendantName: "content-container" })} aria-labelledby="content-heading">
                    <ul className={getClassName({ descendantName: "content-list" })} role={roleTree}>
                        {leftNavItems && leftNavItems.map((item, value) => (
                            <li
                                className={getClassName({ descendantName: "contentlistItems" })}
                                aria-owns={`role_` + value}
                                key={item.leftNavId}>
                                <div id={`#${item.leftNavId}`}
                                    role={roleTreeitem} tabIndex={0}
                                    onClick={() => handleItemClick(item.leftNavId)}
                                    onKeyDown={(e) => handleEnterPress(e, item.leftNavId)}
                                    aria-selected={activeItem === item.leftNavId}
                                    className={getClassName({ descendantName: "contentlistItem-anchor", modifiers: activeItem === item.leftNavId ? "active" : "" })}>
                                    {item.leftNavName}</div>

                                {item.subNav && (
                                    <ul className={getClassName({ descendantName: "sub-content" })} role={roleGroup} id={`role_` + value}>
                                        {item.subNav.map((subItem) => (
                                            <li className={getClassName({ descendantName: "sub-content-list" })}
                                                key={subItem.subNavId}>
                                                <div id={`#${subItem.subNavId}`}
                                                    role={roleTreeitem} tabIndex={0}
                                                    onClick={() => handleItemClick(subItem.subNavId)}
                                                    onKeyDown={(e) => handleEnterPress(e, subItem.subNavId)}
                                                    aria-selected={activeItem === subItem.subNavId}
                                                    className={getClassName({
                                                        descendantName: "subContentlistItem-anchor",
                                                        modifiers: activeItem === subItem.subNavId ? "active" : ""
                                                    })}>{subItem.subNavName}</div>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            }
        </div>
    )
}

LeftNavMobile.displayName = 'LeftNavMobile';